<script>
	import { createEventDispatcher, onDestroy } from 'svelte';

	const dispatch = createEventDispatcher();
	const close = () => dispatch('close');

	let modal;

	const handle_keydown = e => {
		if (e.key === 'Escape') {
			close();
			return;
		}

		if (e.key === 'Tab') {
			// trap focus
			const nodes = modal.querySelectorAll('*');
			const tabbable = Array.from(nodes).filter(n => n.tabIndex >= 0);

			let index = tabbable.indexOf(document.activeElement);
			if (index === -1 && e.shiftKey) index = 0;

			index += tabbable.length + (e.shiftKey ? -1 : 1);
			index %= tabbable.length;

			tabbable[index].focus();
			e.preventDefault();
		}
	};

	const previously_focused = typeof document !== 'undefined' && document.activeElement;

	if (previously_focused) {
		onDestroy(() => {
			previously_focused.focus();
		});
	}
</script>

<svelte:window on:keydown={handle_keydown}/>

<div class="modal-background" on:click={close} on:keyup={handle_keydown}></div>

<div class="modal" role="dialog" aria-modal="true" bind:this={modal}>
	<!-- svelte-ignore a11y-autofocus -->
	<button autofocus on:click={close}>X</button>

	<slot name="header"></slot>
	<slot></slot>

</div>

<style>
	.modal-background {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(20, 5, 23, 0.5);
		z-index: 1000;
		backdrop-filter: blur(5px);;
	}
	.modal {
		position: fixed;
		left: 50%;
		top: 50%;
		width: calc(100vw - 4em);
		max-width: 60em;
		max-height: calc(100vh - 4em);
		overflow-x: hidden;
		overflow-y: auto;
		transform: translate(-50%,-50%);
		padding: 1em;
		border-radius: 0.2em;
		background: #1e1e1e;
		color: #fff;
		border: 2px solid black;
		box-shadow: 2px 2px 4px #5157d4, inset 2px 2px 4px #9c0ccf;
		border-radius: 10px;
		font-size: 0.9rem;
		font-family: Noto Sans Regular;
		z-index:1001;
	}

	button {
		position: inherit;
		right: 0;
		margin-right: 10px;
		display: block;
		border: none;
		background-color: #1e1e1e;
		width: 40px;
		height: 40px;
		color: #fff;
		cursor: pointer;
		z-index: 1;
	}

	button:hover{
		opacity: 0.5;
	}
</style>
